/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'

const educate = {
  path: '/educate',
  component: Layout,
  redirect: '/educate/educate-list',
  name: 'Educate',
  meta: {
    title: 'educate',
    icon: 'xueshimao-shi',
    perm: 'siteTrainManager'
  },
  children: [
    {
      path: 'educate-list',
      component: () => import('@/views/educate/educate-list/index.vue'),
      name: 'EducateList',
      meta: { title: 'educateList', perm: 'siteTrainInfo' }
    },
    {
      path: 'educate-device',
      component: () => import('@/views/educate/face-recognition/index.vue'),
      name: 'EducateDevice',
      meta: { title: 'educateDevice', perm: 'siteTrainDevice' }
    },
    {
      path: 'check-record',
      component: () => import('@/views/educate/check-record/index.vue'),
      name: 'CheckRecord',
      meta: { title: 'checkRecord', perm: 'siteTrainPersonRecord' }
    }
  ]
}
export default educate
